import React, { PureComponent } from 'react';
import { Delete as DeleteIcon, GetApp as DownloadIcon } from '@mui/icons-material';

import { IconButton, Tooltip, Zoom } from '@mui/material';

import BlobFileList, {
  isDeleteButtonDisabled,
  isDownloadButtonDisabled,
} from '../InstrumentDetails/components/FileTransfer/BlobFileList/BlobFileList';

class FileManagement extends PureComponent {
  constructor(props) {
    super();

    this.state = {
      transferNotifications: [],
    };

    this.styleConfig = {
      width: '10%',
    };

    this.columnsConfig = [
      {
        name: 'Serial number',
        key: 'serialnumber',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Type',
        key: 'type',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Region',
        key: 'region',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Group',
        key: 'group',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Location',
        key: 'location',
        type: 'string',
        visible: false,
        filterable: true,
        sortable: true,
      },
      {
        name: 'File name',
        key: 'displayAddress',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'File size (MB)',
        key: 'sizeInMb',
        type: 'number',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Date modified',
        key: 'lastModified',
        visible: false,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Status',
        key: 'status',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Actions',
        key: null,
        type: 'markup',
        style: this.styleConfig,
        markup: (el, col, elIndex, colIndex) => {
          return (
            <div>
              <Tooltip disableInteractive TransitionComponent={Zoom} title="Download">
                <IconButton
                  size="large"
                  key={1}
                  style={{}}
                  onClick={() => {
                    return props.onClickDownload(el.blobLink);
                  }}
                  disabled={isDownloadButtonDisabled(el.status)}
                  data-qa="qa-download"
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
              <Tooltip disableInteractive TransitionComponent={Zoom} title="Delete">
                <IconButton
                  size="large"
                  key={2}
                  style={{}}
                  onClick={() => {
                    return props.onClickDelete(el.blobLink, el.displayAddress);
                  }}
                  disabled={isDeleteButtonDisabled(el.status)}
                  data-qa="qa-delete"
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
        visible: true,
        filterable: false,
        sortable: false,
      },
    ];
  }

  componentWillReceiveProps(newProps) {
    if (JSON.stringify(newProps.notifications) != JSON.stringify(this.props.notifications)) {
      this.setState({ transferNotifications: newProps.notifications });
    }
  }

  render() {
    return (
      <BlobFileList {...this.props} columnsConfig={this.columnsConfig} enableHideColumns={true} />
    );
  }
}

export default FileManagement;
